<script setup>
import { defineProps, defineEmits, ref, watch, computed} from "vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "tiposDeTransporte",
    "revisandoDado",
    "controlesDesativados"
]);

const emits = defineEmits([
    "update:alteraDado",
]);

//==================================================================//
//============================ Refs ================================//
//==================================================================//

const refTransporte = ref(null);

//==================================================================//
//========================= Altera Dado ============================//
//==================================================================//

const alteraDado = (update) =>{

    emits('update:alteraDado',update);

};

//==================================================================//
//===================== Regras Transporte ==========================//
//==================================================================//
    
const regrasTransporte = [
    ncm => {
        if(ncm?.id){
            return true;
        }
        return 'Transporte é obrigatório.';
       
    }
];

//==================================================================//
//=================== Ao Selecionar Transporte =====================//
//==================================================================//

const aoSelecionarTransporte = (transporte) =>{

    alteraDado({
        transporte: transporte || {}
    });

};

//==================================================================//
//==================== Desativa Transporte =========================//
//==================================================================//

const desativaTransporte = computed(()=>{

    if(props?.controlesDesativados){
        return true;
    }

    if(props?.dado?.status == "Em Execução"){
        return true;
    }

    return false;

});

//==================================================================//
//=================== Watch => revisandoDado =======================//
//==================================================================//

watch(()=> props.revisandoDado, async () => {

    if(props.revisandoDado == false){

        refTransporte.value.reset();

    }

});

</script>

<template>

    <v-card class="c-cartao">

        <v-card-title class="c-cartao__titulo">

            <h3 class="c-titulo">

                Transporte

            </h3>

        </v-card-title>

        <div class="c-cartao__conteudo">

            <div class="c-campo">

                <v-autocomplete class="c-busca__input"
                    ref="refTransporte"
                    label="Transporte"
                    :items="props?.tiposDeTransporte"
                    :value="props?.dado?.transporte"
                    :rules="regrasTransporte"
                    :disabled="desativaTransporte"
                    outlined
                    return-object
                    item-text="descricaoCompleta"
                    @input="aoSelecionarTransporte"
                ></v-autocomplete>

            </div>

        </div>

    </v-card>

</template>

<style scoped>

.c-cartao__titulo{
    display: grid; 
    grid-template-columns: 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px; 
    grid-template-areas: 
        "titulo";
}

.c-titulo {
    grid-area: titulo;
}

.c-conjunto-de-campos{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    grid-gap: 0px 20px;
}

</style>